export default {
    report: 'รายงาน',
    dailyReport: 'รายงานรายวัน',
    monthlyReport: 'รายงานรายเดือน',
    empMonthlyLogReport: 'รายงานบันทึกประจำเดือนของพนักงาน',
    allBranch: 'ทุกสาขา',
    attendanceReport: 'การลงชื่อเข้างาน',
    visitorReport: 'กิจกรรมผู้เยี่ยมชม',
    inoutReport: 'รายงานเข้าออกห้องใต้ดิน'
}
